import { Plug, Pencil, StickyNote, MessageSquare, Terminal, Wrench, Power, RefreshCw, PackageX, Undo2, Trash2, RotateCcw } from "lucide-react";
import { ContextMenu, ContextMenuContent, ContextMenuItem, ContextMenuSeparator, ContextMenuTrigger } from "@/components/ui/context-menu";

const Item = ({ id, icon: Icon, label, onSelect, disabled, danger }) => (
  <ContextMenuItem data-testid={`ctx-${id}`} disabled={disabled} onSelect={onSelect} className={danger ? "text-red-600 focus:text-red-700" : ""}>
    <Icon className="h-4 w-4 mr-2" /> {label}
  </ContextMenuItem>
);

export const MachineMenu = ({ m, admin, outdated, latest, canConnect, act, children }) => (
  <ContextMenu>
    <ContextMenuTrigger asChild><div onContextMenu={() => act.select(m)}>{children}</div></ContextMenuTrigger>
    <ContextMenuContent className="w-64" data-testid="machine-context-menu">
      <Item id="connect" icon={Plug} label="Se connecter" disabled={!m.online || !canConnect} onSelect={() => act.connect(m)} />
      <Item id="edit" icon={Pencil} label="Modifier" onSelect={() => act.open("edit", m)} />
      <Item id="note" icon={StickyNote} label="Ajouter une note" onSelect={() => act.open("note", m)} />
      <ContextMenuSeparator />
      <Item id="message" icon={MessageSquare} label="Envoyer un message" disabled={!m.online} onSelect={() => act.open("message", m)} />
      <Item id="command" icon={Terminal} label="Exécuter une commande" disabled={!m.online} onSelect={() => act.open("command", m)} />
      <Item id="toolbox" icon={Wrench} label="Boîte à commandes" disabled={!m.online} onSelect={() => act.open("toolbox", m)} />
      <Item id="restart" icon={RotateCcw} label="Redémarrer" disabled={!m.online} onSelect={() => act.restart(m)} />
      <Item id="wake" icon={Power} label="Réveiller (Wake-on-LAN)" disabled={m.online} onSelect={() => act.wake(m)} />
      {admin && (
        <>
          <ContextMenuSeparator />
          <Item id="update" icon={RefreshCw} label={`Mettre à jour l'agent${latest ? ` (${latest})` : ""}`} disabled={!outdated} onSelect={() => act.update(m)} />
          {m.uninstall_requested_at
            ? <Item id="uninstall-cancel" icon={Undo2} label="Annuler la désinstallation" onSelect={() => act.cancelUninstall(m)} />
            : <Item id="uninstall" icon={PackageX} label="Désinstaller l'agent" danger onSelect={() => act.uninstall(m)} />}
          <Item id="remove" icon={Trash2} label="Supprimer de la liste" danger onSelect={() => act.remove(m)} />
        </>
      )}
    </ContextMenuContent>
  </ContextMenu>
);
